var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148608",
    "data-name": "Rectangle 148608",
    width: 24,
    height: 24,
    transform: "translate(8948 -16182)",
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "me-myfriends",
    transform: "translate(-8948 16182)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11738",
    "data-name": "Group 11738",
    transform: "translate(8948.581 -16176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8898",
    "data-name": "Path 8898",
    d: "M9.741,15.481A2.74,2.74,0,1,0,7,12.74,2.744,2.744,0,0,0,9.741,15.481Z",
    transform: "translate(-5.257 -8.287)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8899",
    "data-name": "Path 8899",
    d: "M9.74,15.481a2.74,2.74,0,1,1,2.74-2.74A2.744,2.744,0,0,1,9.74,15.481Z",
    transform: "translate(8.612 -8.287)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_43",
    "data-name": "Subtraction 43",
    d: "M6.5,5.471H1a1,1,0,0,1-1-1v-1.5A3,3,0,0,1,2.783,0a3.229,3.229,0,0,0,1.7.488A3.228,3.228,0,0,0,6.186,0a3,3,0,0,1,.368.048A3.445,3.445,0,0,0,5.418,2.6V4.322A1.148,1.148,0,0,0,6.5,5.469Z",
    transform: "translate(0 7.445)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_44",
    "data-name": "Subtraction 44",
    d: "M6.5,0H1A1,1,0,0,0,0,1v1.5A3,3,0,0,0,2.783,5.47a3.211,3.211,0,0,1,3.4,0,3,3,0,0,0,.368-.048A3.445,3.445,0,0,1,5.418,2.87V1.149A1.148,1.148,0,0,1,6.5,0Z",
    transform: "translate(22.837 12.915) rotate(180)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8904",
    "data-name": "Path 8904",
    d: "M10.158,16.315A3.158,3.158,0,1,0,7,13.158,3.161,3.161,0,0,0,10.158,16.315Z",
    transform: "translate(1.261 -10)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8905",
    "data-name": "Path 8905",
    d: "M7.127,32.042a3.7,3.7,0,0,1-3.92,0A3.446,3.446,0,0,0,0,35.475V37.2a1.152,1.152,0,0,0,1.148,1.148H9.186A1.152,1.152,0,0,0,10.334,37.2V35.475A3.446,3.446,0,0,0,7.127,32.042Z",
    transform: "translate(6.252 -25.43)",
    fill: "#0c0c0b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersMore);
export default __webpack_public_path__ + "static/media/users-more.6db7a676.svg";
export { ForwardRef as ReactComponent };